import { db } from "@/firebaseConfig";

const ordersCollection = db.collection("orders");

const saveOrder = async (id, data) => {
  ordersCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("Order successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateOrder = async (id, data) => {
  ordersCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Order successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteOrder = async id => {
  ordersCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Order successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getOrderById = async id => {
  return ordersCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getOrdersByRangeOfDates = async (start, end) => {
  return ordersCollection
    .where("time", ">=", start)
    .where("time", "<=", end)
    .orderBy("time")
    .get()
    .then(querySnapshot => {
      let orders = [];
      querySnapshot.forEach(doc => {
        orders.push({ id: doc.id, ...doc.data() });
      });
      return orders;
    })
    .catch(error => {
      throw error;
    });
};

const getOpenOrders = async () => {
  return ordersCollection
    .where("isOpen", "==", true)
    .get()
    .then(querySnapshot => {
      let orders = [];
      querySnapshot.forEach(doc => {
        orders.push({ ...doc.data() });
      });
      return orders;
    })
    .catch(error => {
      throw error;
    });
};

const getLastOrderByTime = async () => {
  return ordersCollection
    .orderBy("time", "desc")
    .limit(1)
    .get()
    .then(querySnapshot => {
      let orders = [];
      querySnapshot.forEach(doc => {
        orders.push({ ...doc.data() });
      });
      return orders;
    })
    .catch(error => {
      throw error;
    });
};

const getOpenOrdersByTableQR = async tableQR => {
  return ordersCollection
    .where("isOpen", "==", true)
    .where("tableQR", "==", tableQR)
    .get()
    .then(querySnapshot => {
      let orders = [];
      querySnapshot.forEach(doc => {
        orders.push({ ...doc.data() });
      });
      return orders;
    })
    .catch(error => {
      throw error;
    });
};

export {
  ordersCollection,
  saveOrder,
  updateOrder,
  deleteOrder,
  getOrderById,
  getOrdersByRangeOfDates,
  getOpenOrders,
  getLastOrderByTime,
  getOpenOrdersByTableQR
};
